import { Capacitor, registerPlugin } from '@capacitor/core';
import type { PlaidLinkPlugin } from './types';

const _plugin = registerPlugin<PlaidLinkPlugin>('PlaidLink', {
  web: () => import('./web').then((m) => new m.PlaidLinkWeb()),
});

export const isPlaidAvailable = (): boolean => Capacitor.isPluginAvailable('PlaidLink');

export const PlaidLink: PlaidLinkPlugin = {
  create: (opts) => _plugin.create(opts),
  open: () => _plugin.open(),
  continueFromRedirect: (opts) => _plugin.continueFromRedirect(opts),
  destroy: () => _plugin.destroy(),
  getPendingResult: () => _plugin.getPendingResult(),
  addListener: _plugin.addListener.bind(_plugin) as PlaidLinkPlugin['addListener'],
  removeAllListeners: () => _plugin.removeAllListeners(),
};
